// eslint-disable-next-line import/prefer-default-export
export const upgradeAccountScreens = {
  START_UPGRADE: 'start_upgrade',
  UPGRADE_LEVEL: 'upgrade_level',
  INFO_POPUP: 'info_popup',
};

export const MAX_FILES_NUMBER = 5;

export const allowedExtension = ['png', 'pdf', 'jpg', 'jpeg'];
